import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, of, shareReplay } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AdBanner, PartnerAdvertiser, TechNewsItem } from '../models/sidebar-widgets.model';

// Blocs de la colonne de droite (publicité Awin / Amazon, nos partenaires, dernières actualités) :
// routes publiques de l'API, gardées en mémoire le temps de la session (la colonne est recréée à chaque page)
@Injectable({
  providedIn: 'root'
})
export class SidebarWidgetsService {

  private banners$?: Observable<AdBanner[]>;
  private partners$?: Observable<PartnerAdvertiser[]>;
  private news$?: Observable<TechNewsItem[]>;

  constructor(private httpClient: HttpClient) { }

  adBanners(): Observable<AdBanner[]> {
    return this.banners$ ??= this.cached<AdBanner[]>('/ad-banners/public');
  }

  partners(): Observable<PartnerAdvertiser[]> {
    return this.partners$ ??= this.cached<PartnerAdvertiser[]>('/advertisers/partners?limit=9');
  }

  techNews(): Observable<TechNewsItem[]> {
    return this.news$ ??= this.cached<TechNewsItem[]>('/tech-news?limit=5');
  }

  private cached<T>(path: string): Observable<T> {
    return this.httpClient.get<T>(environment.host + path).pipe(
      catchError(() => of([] as unknown as T)),
      shareReplay(1),
    );
  }
}
